import { useEffect, useRef, useState } from 'react'

/**
 * Custom hook to detect when the reader has scrolled to the bottom stats section,
 * allowing the floating dock to dock into standard document flow so it does not block the footer.
 *
 * @returns An object containing the sentinel element ref and whether the bottom is reached
 */
export const useDockScrollPosition = () => {
  const [isDockedAtBottom, setIsDockedAtBottom] = useState(false)
  const sentinelRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const target = sentinelRef.current
    if (!target) return

    // IntersectionObserver watches for when the stats section enters the viewport
    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsDockedAtBottom(entry.isIntersecting)
      },
      {
        root: null,
        // Trigger slightly before reaching the bottom
        rootMargin: '0px 0px 50px 0px',
        threshold: 0.1,
      },
    )

    observer.observe(target)
    return () => observer.disconnect()
  }, [])

  return { sentinelRef, isDockedAtBottom }
}
